import React from 'react';
import { Users, FileText, Briefcase, CheckCircle } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: Users,
      title: 'IT Staffing',
      items: [
        'Requirement intake through vendor/MSP channels',
        'Resume screening support and submission coordination',
        'Interview scheduling and communication support',
        'Offer/onboarding documentation coordination (as applicable)'
      ]
    },
    {
      icon: FileText,
      title: 'Contract Workforce (CW)',
      items: [
        'Contract engagement support aligned with vendor processes',
        'Timesheet coordination and billing support (as applicable)',
        'Contractor lifecycle coordination: onboarding, changes, exit documentation'
      ]
    },
    {
      icon: Briefcase,
      title: 'Professional Consulting',
      items: [
        'Consulting delivered under defined scope of work (SOW)',
        'Project/program support under agreed terms',
        'Vendor-to-vendor consulting engagements'
      ]
    }
  ];

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-slate-50 to-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">Our Services</h1>
            <p className="text-xl text-gray-600">
              Structured, documentation-driven services for vendor and MSP partners.
            </p>
          </div>
        </div>
      </section>

      {/* Services Detail */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="space-y-16">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <div key={index} className="bg-gray-50 rounded-lg p-8 md:p-12 border border-gray-200">
                <div className="flex items-center mb-8">
                  <div className="w-14 h-14 bg-blue-900 rounded-lg flex items-center justify-center mr-6">
                    <IconComponent size={28} className="text-white" />
                  </div>
                  <h2 className="text-3xl font-bold text-gray-900">{service.title}</h2>
                </div>
                <div className="space-y-4">
                  {service.items.map((item, itemIndex) => (
                    <div key={itemIndex} className="flex items-start">
                      <CheckCircle size={20} className="text-blue-900 mr-3 mt-1 flex-shrink-0" />
                      <p className="text-lg text-gray-700">{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Mandatory Footer Notice */}
      <section className="bg-blue-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <p className="text-center text-sm">
            All services are subject to written agreements, approvals, and applicable statutory requirements.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Services;